import MinusIcon from './component'

export default MinusIcon
